import React from "react";
import { useSelector } from "react-redux";
import { HeaderContent } from "./HeaderContent";
import { useSEO } from "../../hooks/components/SEO/useSEO";

const Header = ({ children }) => {
  const theme = useSelector((state) => state.configuration.site.theme);
  const siteSetting = useSelector((state) => state.configuration.site.settings);
  const { SEO } = useSEO();

  const getContentByElementVal = (children, value) => {
    return children?.filter((child) => child?.props?.el.contentElementTypeCode === value);
  };

  const ribbons = getContentByElementVal(children, "cetRibbon");
  const menus = getContentByElementVal(children, "cetMenu");
  const megaMenus = getContentByElementVal(children, "cetMegaMenu");
  const filteredMenus = menus?.filter((menu) => menu.props.el.contentElementName !== "Filter Header Menu");

  return (
    <header style={{ backgroundColor: theme.headerBarColor?.trim() }} className="col-12">
      <SEO />
      <HeaderContent
        ribbons={ribbons}
        megaMenus={megaMenus}
        filteredMenus={filteredMenus}
        theme={theme}
        siteSetting={siteSetting}
      />
    </header>
  );
};

export { Header };
